<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
         <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">简介</a></p>
         <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">硬件</a></p>
         <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">建立一个网站</a></p>
          <!-- <div class="subAnchor">
            <p @click="activeted(2)" class="s2"><a :class="{active:flag==2}" href="#box2">What GetVersion contains</a></p>
            <p @click="activeted(3)" class="s2"><a :class="{active:flag==3}" href="#box3">How GetVersion is handled</a></p>
            <p @click="activeted(4)" class="s2"><a :class="{active:flag==4}" href="#box4">When GetVersion is sent</a></p>
    
          </div> -->
        </div>
      </div>
      <div class="p1">验证器概述</div>
      <div id="box1" class="p4">简介</div>
      <div class="p3">Fax 基于 Tendermint，它依赖于一组负责在区块链中提交新块的验证器。这些验证者通过广播投票参与共识协议，其中包含由每个验证者的私钥签名的加密签名。</div>
      <div class="p3">验证人候选人可以绑定他们自己的 fax，并让代币持有者将 fax “委托”或质押给他们。Fax 网络将有 23 个验证者。验证人由收集最多质押 fax 的人的排名决定——质押最多的前23 名验证人候选人将成为 Fax 验证人。</div>
      <div class="p3">验证者将通过执行 Tendermint 共识协议获得 fax 作为区块规定和代币作为交易费用，并且委托人应该以自己的方式从目标验证者那里获得奖励。最初，交易费用将以faxs 支付，但在未来，如果 Fax 生态系统中的任何代币被治理列入白名单，它将作为费用投标有效。请注意，验证者可以为其委托人收取的费用设置佣金，作为额外的激励。</div>
      <div id="box2" class="p4">硬件</div>
      <div class="p3">当前不存在用于验证者密钥管理的合适的云解决方案。当云 SGX 变得更广泛可用时，这种情况可能会改变。出于这个原因，验证者必须设置一个受限制访问的物理操作。例如，一个很好的起点是在安全的数据中心共存。</div>
      <div class="p3">验证者应该期望为他们的数据中心配备冗余电源、连接和存储备份。建议使用多个用于光纤、防火墙和交换的冗余网络盒，以及带有冗余硬盘驱动器和故障转移的小型服务器。</div>
      <div class="p3">我们预计最初的网络要求会很低。当前的测试网需要最少的资源。随着网络的增长，带宽、CPU 和内存需求将会增加。建议使用大硬盘来存储完整的区块链历史。</div>
      <div id="box3" class="p4">建立一个网站</div>
      <div class="p3">建立一个专门的验证者网站，并在我们的聊天中表明您打算成为验证者。这一点很重要，因为委托人将希望访问有关他们将 fax 委托给的实体的基本信息。</div>
      
      
    </div>
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">简介</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">硬件</a></p>
      <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">建立一个网站</a></p>
      <!-- <div class="subAnchor">
        <p @click="activeted(2)" class="s2"><a :class="{active:flag==2}" href="#box2">What GetVersion contains</a></p>
        <p @click="activeted(3)" class="s2"><a :class="{active:flag==3}" href="#box3">How GetVersion is handled</a></p>
        <p @click="activeted(4)" class="s2"><a :class="{active:flag==4}" href="#box4">When GetVersion is sent</a></p>

      </div> -->
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NetworkProtocol',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>